let url = "http://0.0.0.0:5100";

if (process.env.REACT_APP_ET_ENV === "stage") {
    url = "https://server.et-stage.hame.dev";
} else if (process.env.REACT_APP_ET_ENV === "production") {
    url = "https://server.estimatetasks.com";
}

export const baseUrl = url;
